import React from 'react';
import FormRow from "./FormRow";
import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import PropTypes from "prop-types";
import StackedFormRow from "../StackedForm/StackedFormRow";

const ConfigFormRow = (props) => {

    const FormRowComponent = (props.isStacked)
        ? StackedFormRow
        : FormRow;

    const handleOverrideClick = (event) => {
        if (isParentValueOverridden()) {
            props.onChange(props.name, null)
        } else {
            props.onChange(props.name, props.parentValue ?? '')
        }
    }

    const isParentValueOverridden = () => {
        if (!props.isOverride) {
            return null;
        }

        return (props.value !== null)
    }

    const isDisabled = () => {
        if (!props.isOverride) {
            return false;
        }
        return (isParentValueOverridden()) ? false : true
    }

    const getOverriddenValue = () => {
        if (!props.isOverride || isParentValueOverridden()) {
            return props.value;
        }

        if (props.parentValue !== null) {
            return props.parentValue;
        }

        return '';
    }

    const handleChange = (name, value) => {
        if (name.target) {
            // If the change is an event object
            props.onChange(name.target.name, name.target.value)
        } else {
            props.onChange(name, value)
        }
    }

    // Override child props with locally determined props
    // note: .cloneElement is not recommended but it seems to be the best way to override props in a child element
    const newChild = React.cloneElement(
        props.children,
        {
            name: props.name,
            value: getOverriddenValue(),
            onChange: handleChange,
            disabled: isDisabled(),
        }
    )

    if (!props.isOverride) {
        return (
            <FormRow {...props} >
                {newChild}
            </FormRow>
        )
    }

    return (
        <div className="grid-x">
            <div className="cell small-1">
                {(isParentValueOverridden())
                    ? (
                        <LockOpenIcon
                            style={{marginTop: '0.5rem'}}
                            onClick={(e) => handleOverrideClick(e)}
                        />
                    )
                    : (
                        <LockIcon
                            style={{marginTop: '0.5rem'}}
                            onClick={(e) => handleOverrideClick(e)}
                        />
                    )
                }
            </div>
            <div className="cell small-11">
                <FormRowComponent
                    // TODO - don't pass name, value, onchange
                    {...props}
                    disabled={isDisabled()}
                >
                    {newChild}
                </FormRowComponent>
            </div>
        </div>
    )
}

ConfigFormRow.propTypes = {
    isOverride: PropTypes.bool,
    isStacked: PropTypes.bool,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    parentValue: PropTypes.any

}

ConfigFormRow.defaultProps = {
    isOverride: false,
    isStacked: false,
}

export default ConfigFormRow;
